import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    layout: {
      //   border: '2px solid red',
      height: '60%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
      padding: '0 30px',
    },
    loginhelpoutinstaller: {
      display: 'flex',
      justifyContent: 'space-between',
      textAlign: 'center',
    },
    loginhelpoutcs: {
      display: 'flex',
      justifyContent: 'flex-end',
      textAlign: 'center',
    },
    submit: {
      display: 'flex',
      justifyContent: 'space-around',
    },
  }),
  { index: 1 },
)

export { useStyles }
